import { createFileRoute } from "@tanstack/react-router";
import MockupPublish from "@/pages/MockupPublish";
import { routeHead } from "@/lib/seo/route-head";

export const Route = createFileRoute("/mockup-publish/")({
  head: () => routeHead("/mockup-publish/"),
  component: RouteComponent,
});

function RouteComponent() {
  return (
    <MockupPublish />
  );
}
